// extracted by mini-css-extract-plugin
export default {"root":"quickNote_root__Bvbri","rootHidden":"quickNote_rootHidden__jbWfA","content":"quickNote_content__qcs7k"};